import { render, staticRenderFns } from "./CountryDistributionPie.vue?vue&type=template&id=d52614e2&scoped=true&"
import script from "./CountryDistributionPie.vue?vue&type=script&lang=ts&"
export * from "./CountryDistributionPie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52614e2",
  null
  
)

export default component.exports